import React, { useState, useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { Grid, Typography, Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import ParkingWeek from "../components/forms/partner/ParkingWeek";
import Calendar from "../components/calendar/Calendar";
import Page from "../layouts/pages/PageLayout";
import SpeedDialButton from "../components/SpeedDialButton";
import LocalParking from "@material-ui/icons/LocalParking";
import Header from "../layouts/headers/pages/PartnerHeaderLayout";
import CreateParking from "../components/forms/partner/CreateParking";
import SendInvitation from "../components/forms/partner/SendInvitation";
import PieChart from "../components/partner/charts/PieChart";
import SimpleArea from "../components/partner/charts/SimpleArea";
import useSessionState from "../state/hooks/session/useSessionState";
import User from "../models/user.model";
import { constantsApp } from "../constants/constants.app";

const dataPerDay = [
  {
    name: "Monday",
    amount: 4000
  },
  {
    name: "Tuesday",
    amount: 3000
  },
  {
    name: "Wednesday",
    amount: 2800
  },
  {
    name: "Thursday",
    amount: 2780
  },
  {
    name: "Friday",
    amount: 1890
  },
  {
    name: "Saturday",
    amount: 2390
  },
  {
    name: "Sunday",
    amount: 3490
  }
];

function PartnerPage({ classes }) {
  const { isLoggedIn, loading, user } = useSessionState();
  const [parkings, setParkings] = useState(false);
  const [state, setState] = useState({
    week: null,
    showConfigParkingForm: false,
    showForm: false,
    showCreateParkingForm: false,
    showSendInvitationForm: false
  });
  const getWeek = week => {
    setState(prevState => ({ ...prevState, week }));
  };
  useEffect(() => {
    if (!loading && isLoggedIn && user && user.role === "partner") {
      user.getParkings().then(setParkings);
    } else if (!loading && isLoggedIn && user && user.role !== "partner") {
      setParkings([]);
    }
  }, [loading, isLoggedIn, user, user.role]);

  const buttons = [
    {
      id: "addParking",
      title: constantsApp.pages.partnerPage.ADD_PARKING_BUTTON,
      icon: <LocalParking />,
      action: () => {
        setState(prevState => ({
          ...prevState,
          showForm: true,
          showCreateParkingForm: true
        }));
      }
    },
    {
      id: "sendInvitation",
      title: constantsApp.pages.partnerPage.SEND_INVITATION_BUTTON,
      icon: <LocalParking />,
      action: () => {
        setState(prevState => ({
          ...prevState,
          showForm: true,
          showSendInvitationForm: true
        }));
      }
    },
    {
      id: "addConfig",
      title: constantsApp.pages.partnerPage.ADD_SCHEDULE_BUTTON,
      icon: <LocalParking />,
      action: () =>
        setState(prevState => ({
          ...prevState,
          showForm: true,
          showConfigParkingForm: true
        }))
    }
  ];
  const {
    showConfigParkingForm,
    showSendInvitationForm,
    showCreateParkingForm
  } = state;
  const theresForms =
    showCreateParkingForm || showConfigParkingForm || showSendInvitationForm;

  const toggleForm = action => {
    setState(prevState => {
      prevState[action] = !prevState[action];
      return { ...prevState };
    });
  };

  return (
    <Page
      header={
        <Header toggleForm={toggleForm} setState={setState} state={state} />
      }
    >
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ marginTop: 20 }}
      >
        {!theresForms &&
          (loading || !isLoggedIn ? (
            <BeatLoader />
          ) : !parkings ? (
            <BeatLoader />
          ) : parkings.length > 0 ? (
            <>
              <Typography variant="h3" color="secondary">
                Estacionamientos
              </Typography>
              <ul>
                {parkings.map(parking => (
                  <li key={parking.id}>{parking.spotNumber}</li>
                ))}
              </ul>
            </>
          ) : (
            <Typography variant="subtitle1">
              No hay estacionamiento registrado para este usuario.
            </Typography>
          ))}

        {showCreateParkingForm && (
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} lg={8}>
              <CreateParking onCancel={toggleForm} />
            </Grid>
          </Grid>
        )}
        {showSendInvitationForm && (
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12} lg={8}>
              <SendInvitation onCancel={toggleForm} />
            </Grid>
          </Grid>
        )}
        {showConfigParkingForm && (
          <Grid container justify="center" alignItems="center" spacing={3}>
            <Grid item xs={12} lg={8}>
              <Calendar getWeek={getWeek} />
            </Grid>
            <Grid item xs={12} lg={8}>
              <ParkingWeek week={state.week} onCancel={toggleForm} />
            </Grid>
          </Grid>
        )}
        {!state.showForm && (
          <>
            <Grid container justify="center" alignItems="center">
              <Typography variant="h3" color="secondary">
                Estadisticas semanales
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleArea
                data={dataPerDay}
                XAxisDataKey="name"
                AreaDataKey="amount"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container justify="space-between" direction="row">
                <Typography variant="h5" color="secondary">
                  Ingresos Totales
                </Typography>
                <Typography variant="h4" color="secondary">
                  $50.000
                </Typography>
              </Grid>
              <Grid container justify="space-between" direction="row">
                <Typography variant="h5" color="secondary">
                  15% Oo-Park
                </Typography>
                <Typography variant="h4" color="secondary">
                  $7.500
                </Typography>
              </Grid>
              <Grid container justify="space-between" direction="row">
                <Typography variant="h5" color="secondary">
                  5% Comunidad
                </Typography>
                <Typography variant="h4" color="secondary">
                  $2.500
                </Typography>
              </Grid>
              <Divider classes={{ root: classes.divider }} />
              <Grid container justify="space-between" direction="row">
                <Typography variant="h5" color="secondary">
                  Total cancelar a propietario
                </Typography>
                <Typography variant="h4" color="secondary">
                  $40.00
                </Typography>
              </Grid>
            </Grid>

            <Grid container justify="center" alignItems="center">
              <Grid item xs={12} md={6}>
                <Grid container justify="space-between" direction="row">
                  <Typography variant="h5" color="secondary">
                    Ingresos promedio por día
                  </Typography>
                  <Typography variant="h4" color="secondary">
                    $5.000
                  </Typography>
                </Grid>
                <Grid container justify="space-between" direction="row">
                  <Typography variant="h5" color="secondary">
                    Horas promedio diarias
                  </Typography>
                  <Typography variant="h4" color="secondary">
                    6 hrs
                  </Typography>
                </Grid>
                <Grid container justify="space-between" direction="row">
                  <Typography variant="h5" color="secondary">
                    % De uso estacionamiento
                  </Typography>
                  <Typography variant="h4" color="secondary">
                    40 %
                  </Typography>
                </Grid>
                <Divider classes={{ root: classes.divider }} />
                <Grid container justify="space-between" direction="row">
                  <Typography variant="h5" color="secondary">
                    Horas de mayor uso
                  </Typography>
                  <Typography variant="h4" color="secondary">
                    8:00 AM , 13:00 PM, 15:00 PM
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <PieChart
                  data={dataPerDay}
                  XAxisDataKey="name"
                  AreaDataKey="amount"
                />
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
      <SpeedDialButton
        toggleForm={toggleForm}
        hidden={state.showForm}
        buttons={buttons}
      />
    </Page>
  );
}

const styles = theme => ({
  divider: { marginBottom: theme.spacing(1) }
});

export default withStyles(styles)(PartnerPage);
